const suggestions = [
    {
        name: 'Early Childhood',
        id: '1',
        url: 'https:mysite.com/early-childhood',
    },
    {
        name: 'Primary School',
        id: '2',
        url: 'https:mysite.com/primary-school',
    },
    {
        name: 'Secondary School',
        id: '3',
        url: 'https:mysite.com/secondary-school',
    },
    {
        name: 'Tertiary Education',
        id: '4',
        url: 'https:mysite.com/tertiary-education',
    },
    {
        name: 'Parents, Families and Carers',
        id: '5',
        url: 'https:mysite.com/parents-families-carers',
    },
    {
        name: 'Young and Novice Drivers',
        id: '6',
        url: 'https:mysite.com/young-novice-drivers',
    },
    {
        name: 'School Leaders',
        id: '7',
        url: 'https:mysite.com/school-leaders',
    },
];

export default suggestions;
